import service from '@/services/inventario/item'

const item = {
  emisor: { id: '' },
  nombre: '',
  stockState: true,
  codigoRapido: '',
  SKU: '',
  nombreCorto: '',
  descripcion: '',
  tag: [],
  bajoDemanda: false,
  bajoProduccion: false,
  permiteInventarioNegativo: false,
  tipo: { id: '' }, // reventa 02 - manufactura 03 - consumible 04
  // img: {}, // es dinamico solo si agrega la imagen
  altImg: [],
  //
  codigo: '', // CABYS
  // codigoComercial: [], // no se usa en esta version. No es requerido por Hacienda.
  clasificacion: '', // producto - servicio
  unidadMedida: { id: '' },
  codigoMoneda: { id: '' },
  unidadMedidaComercial: '',
  costoUnitarioTotal: 0,
  precioCompra: 0,
  utilidad: 45,
  precioUnitario: 0,
  descuento: [],
  impuesto: [],

  esCompuesto: false,
  precioInvertido: true,

  // cantidad: 0,
  pp: 0,
  minimo: 0,
  maximo: 0,

  composicion: [],
  listaCostos: [],

  duracion: 0,
  checkIn: null,
  checkOut: null,
  nextDay: false,

  categoria: [],
  subCategorias: [],

  cuentaContablePorCobrar: null,
  cuentaContablePorPagar: null,

  customVariantPrice: false,
  showVariantAsOptions: false

  // modoivaIncluido: false
}

const getDefaultState = () => ({
  item,

  listVariants: [],
  variants: [],
  listVariantsToBill: [], // lista de variantes cargadas en memoria.
  variantsToBill: [], // variantes para facturar de un producto seleccionado.

  item_materiaPrimaList: item,
  item_reventaList: item,
  item_manufacturaList: item,
  item_consumibleList: item,
  item_servicioList: item,

  itemsCompras: [], // lista de items para factura de proveedor (compras)

  stock: [],
  stockPageInfo: {},

  stockByItem: [],
  stockByItemPageInfo: {},

  materiaPrimaList: [],
  materiaPrimaPageInfo: {},

  reventaList: [],
  reventaPageInfo: {},

  manufacturaList: [],
  manufacturaPageInfo: {},

  consumibleList: [],
  consumiblePageInfo: {},

  servicioList: [],
  servicioPageInfo: {},

  servicioBillingList: [],
  productoBillingList: [],

  completeList: [],

  currentRow: [
    {
      tipoProducto: '01',
      row: null
    },
    {
      tipoProducto: '02',
      row: null
    },
    {
      tipoProducto: '03',
      row: null
    },
    {
      tipoProducto: '04',
      row: null
    },
    {
      tipoProducto: '05',
      row: null
    }
  ],
  currentRowInventario: {},
  currentRowVariant: null,

  saved: 'null',
  isListening: false,

  variantWindow: false,

  precioVentaEditable: { value: null }

  // searchString: '',
  // searchedDB: false,
  // searchedData: []
})

export const state = () => getDefaultState()

export const mutations = {
  // FIXME: está limpiando las listas y proboca ir a BD de nuevo.
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  // SET_SEARCHEDDB: (state, val) => (state.searchedDB = val),
  SET_ROW: (state, row) => {
    const crow = state.currentRow.find(r => r.tipoProducto === row?.tipo.value)

    if (crow) crow.row = row
  },
  SET_VARIANT_ROW: (state, row) => {
    state.currentRowVariant = row
  },
  SET_ROW_INVENTARIO: (state, row) => (state.currentRowInventario = row),
  SET_ITEM: (state, { input, storeList }) => {
    state.item = input

    if (storeList) state[`item_${storeList}`] = input

    state.saved = true
  },
  UPDATE_ITEM: (state, { input, storeList }) => {
    state.item = input

    if (storeList) state[`item_${storeList}`] = { ...state[`item_${storeList}`], ...input }

    state.saved = true
  },
  UPDATE_CANTIDAD: (state, cant) => {
    state.item.cantidad = cant
  },
  SET_PP: (state, val) => {
    state.item.pp = val
  },
  SET_LIST: (state, { storeList, storePageInfo, obj }) => {
    state[storeList] = [...new Set([...state[storeList].map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    // state[storeList].push(...obj.feed)
    state[storePageInfo] = obj.pageInfo
  },
  SET_STOCK: (state, obj) => {
    state.stock = [...new Set([...state.stock.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)

    state.stockPageInfo = obj.pageInfo
  },
  SET_STOCK_BY_ITEM: (state, obj) => {
    state.stockByItem = obj.feed
    state.stockByItemPageInfo = obj.pageInfo
  },
  SET_SERVICIO_BILLING_LIST: (state, { obj }) => {
    const servicioVenta = obj.feed.filter(e => e.stockState !== false)

    state.servicioBillingList = [...new Set([...state.servicioBillingList.map(JSON.stringify), ...servicioVenta.map(JSON.stringify)])].map(JSON.parse)
  },
  SET_PRODUCTO_BILLING_LIST: (state, { obj }) => {
    const productoVenta = obj.feed.filter(e => e.stockState !== false)

    state.productoBillingList = [...new Set([...state.productoBillingList.map(JSON.stringify), ...productoVenta.map(JSON.stringify)])].map(JSON.parse)
  },
  UPDATE_PRODUCTO_STOCK_BILLING_LIST: (state, obj) => {
    obj.forEach(item => {
      if (item.clasificacion === 'producto') {
        const producto = state.productoBillingList?.find(e => {
          return e._id === item.item._id
        })

        if (producto) producto.cantidad -= item.cantidad
        else {
          const vari = state.listVariantsToBill?.find(e => {
            return e._id === item.item._id
          })

          if (vari) vari.cantidad -= item.cantidad
        }
      }
    })
  },
  SET_LIST_ITEMS_COMPRAS: (state, obj) => {
    state.itemsCompras.push(...obj)
  },
  RESET_LIST_ITEMS_COMPRAS: state => {
    state.itemsCompras = []
  },
  SET_FACTURAS_BY_DATE: (state, obj) => {
    state.stock = obj.feed
    state.stockPageInfo = obj.pageInfo
  },
  ADD_LIST_ITEMS_COMPRAS: (state, obj) => {
    state.itemsCompras = [obj, ...state.itemsCompras]
  },
  UPDATE_LIST: (state, { storeList, obj }) => {
    const nObj = state[storeList].find(e => e._id === obj._id)

    if (!nObj) state[storeList] = [obj, ...state[storeList]]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true

    // TODO: actualiza campos por suscripcion
    // else {
    //   nObj.x = obj.x
    // }
  },
  DELETE_LIST: (state, { storeList, obj }) => {
    state[storeList] = state[storeList].filter(e => e._id !== obj._id)
  },
  RESET: (state, { clasificacionDef, tipoDef, unidadDef, codigo, monedaDef, storeList /* modoivaIncluidoDef */ }) => {
    state[`item_${storeList}`] = {
      ...getDefaultState().item,
      codigo, // CABYS
      tag: [],
      altImg: [],
      descuento: [],
      impuesto: [],
      clasificacion: clasificacionDef,
      tipo: { id: tipoDef },
      unidadMedida: { id: unidadDef.id },
      codigoMoneda: { id: monedaDef.id }
      // modoivaIncluido: modoivaIncluidoDef
    }
    state.precioVentaEditable.value = null
  },
  SET_PRECIO_VENTA_EDITABLE: (state, val) => {
    state.precioVentaEditable.value = val
  },
  SAVE_CHANGES: (state, obj) => {
    state.item = obj
    state.saved = false
  },
  SET_COMPLETE_LIST: (state, obj) => {
    state.completeList = obj
  },
  SET_SUBCATEGORIAS: (state, obj) => {
    state.item.subCategorias = obj
  },
  RESET_VARIANTS: state => {
    state.listVariants = []
    state.variants = []
  },
  RESET_ITEM_VARIANTS: state => {
    state.variantsToBill = []
  },
  SET_ACCOUNT: (state, { cuentaContablePorCobrar, cuentaContablePorPagar }) => {
    state.item.cuentaContablePorCobrar = cuentaContablePorCobrar
    state.item.cuentaContablePorPagar = cuentaContablePorPagar
  },
  SET_VARIANT_WINDOW: (state, val) => {
    state.variantWindow = val ?? JSON.parse(localStorage.getItem('VARIANT_WINDOW') || 'false')
    localStorage.setItem('VARIANT_WINDOW', JSON.stringify(state.variantWindow))
  }
}

export const actions = {
  create: async ({ state, commit, rootGetters }, { storeList, input }) => {
    delete input.createdAt
    delete input.updatedAt
    delete input.img
    delete input.altImg
    delete input.attributes
    delete input.impuestos
    delete input.descuentos
    delete input.pdescuento
    delete input.pimpuesto
    delete input.ganancia
    delete input.subtotal
    // delete input.cantidad // la cantidad no se edita directamente. se debe hacer por medio de una entrada/salida/ajuste

    // busca si es una composicion y valida los valores numéricos

    return service
      .create({
        ...input,
        precioUnitario: Number(parseFloat(input.precioUnitario).toFixed(5)),
        costoUnitarioTotal: Number(parseFloat(input.costoUnitarioTotal).toFixed(5)),
        utilidad: Number(parseFloat(input.utilidad).toFixed(5)),
        minimo: Number(parseFloat(input.minimo).toFixed(5)),
        maximo: Number(parseFloat(input.maximo).toFixed(5)),
        posIndex: input.posIndex || 99999,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        },
        ...(input.esCompuesto && {
          composicion: input.composicion.map(e => ({
            ...e,
            porcion: Number(e.porcion)
          }))
        })
      })
      .then(result => {
        // evita la actualización de la lista.

        if (state.searchedDB) return (state.saved = true)

        commit('UPDATE_LIST', {
          storeList,
          obj: { ...input, _id: result._id }
        })

        commit('UPDATE_ITEM', { input: { _id: result._id }, storeList })

        return result
      })
  },

  updateUnidadMedida: async ({ commit, rootGetters }, { _id, _idUnidadMedida }) => {
    return service.updateUnidadMedida({
      _id,
      _idUnidadMedida,
      _idEmisor: await rootGetters['facturacion/emisorStore/get_Id']
    })
  },

  ajuste: async ({ commit, rootGetters }, input) => {
    return service.ajuste({
      ...input,
      emisor: { _id: await rootGetters['facturacion/emisorStore/get_Id'] }
    })
    // .then(result => {
    //   commit('UPDATE_LIST', {
    //     storeList,
    //     obj: { ...input, _id: result._id }
    //   })

    //   return result
    // })
  },

  readById: async ({ state, commit }, { _id, storeList, refresh = false }) => {
    let input = {}
    if (refresh) {
      console.log('Busca item en bd 💣')
      input = await service.readById(_id)
    } else {
      console.log('Item from Cache ⏩', storeList)
      input = state[storeList].find(e => e._id === _id)
    }

    commit('SET_ITEM', { input, storeList })

    return input
  },

  readBySearchString: async ({ rootGetters }, { searchString, tipo }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString, tipo),

  readMovimientosBySearchString: async ({ rootGetters }, { searchString }) =>
    service.readMovimientosBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString),

  readByCodigoRapido: async (_, codigoRapido) => service.readByCodigoRapido(codigoRapido),

  readItemsCompras: async ({ commit, state, rootGetters }, { refresh = false }) => {
    if (refresh) commit('RESET_LIST_ITEMS_COMPRAS')
    if (state.itemsCompras.length !== 0 && !refresh) {
      console.log('itemsCompras from cache ⏩')
      return false
    }

    return service.readItemsCompras(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      commit('SET_LIST_ITEMS_COMPRAS', result)

      console.log('Items compras from db 😥')

      return true
    })
  },

  addItemCompras: async ({ commit, rootGetters }, input) => {
    const it = {
      nombre: input.detalle,
      codigo: input.codigo,
      precioUnitario: input.montoTotalLinea / input.cantidad,
      // descuento: input.descuento,
      // impuesto: input.impuesto,
      SKU: '',
      tipo: input.tipo,
      emisor: { _id: rootGetters['facturacion/emisorStore/get_Id'] },
      codigoMoneda: input.codigoMoneda,
      unidadMedida: input.unidadMedida,
      clasificacion: input.clasificacion
    }

    return service.addItemCompras(it).then(result => {
      commit('ADD_LIST_ITEMS_COMPRAS', result)
      return result._id
    })
  },

  resetList: ({ state }, { storeList, storePageInfo }) => {
    state[storeList] = []
    state[storePageInfo] = {}
  },

  resetStock: ({ state }) => {
    state.stock = []
    state.stockPageInfo = {}
  },

  resetBillingList: ({ state }) => {
    state.servicioBillingList = []
    state.productoBillingList = []
  },

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, tipo = '02', storeList, storePageInfo, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList', { storeList, storePageInfo })

    // manufactura, reventa, consumible: tipoProducto === '02' - '03' - '04'
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state[storePageInfo].nextPageCursor, tipo, limit, filter).then(result => {
      commit('SET_LIST', { storeList, storePageInfo, obj: result })

      // if (!state.isListening) {
      //   // TODO: Subs para cada tipo
      //   state.isListening = true
      //   // dispatch('subscriptionNewMateriaPrima')
      // }

      return true
    })
  },

  readByDateRange: async ({ commit, dispatch, rootGetters }, { inicio, final }) => {
    await dispatch('resetStock')

    return service.readByDateRange(rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return commit('SET_FACTURAS_BY_DATE', result)
    })
  },

  readAllStock: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 15, filter = null, byItem = null }) => {
    if (restart) await dispatch('resetStock')

    return service.readAllStock(rootGetters['facturacion/emisorStore/get_Id'], state.stockPageInfo.nextPageCursor, limit, filter).then(result => {
      if (byItem) {
        commit('SET_STOCK_BY_ITEM', result)

        commit('UPDATE_CANTIDAD', result.feed[0]?.saldo.cantidad)
      } else commit('SET_STOCK', result)
      return true
      // if (!state.isListening) {
      //   // TODO: Subs de stock
      //   state.isListening = true
      //   // dispatch('subscriptionNewMateriaPrima')
      // }
    })
  },

  readToBill: async ({ commit, state, dispatch, rootGetters }, { restart = false, tipo = '05', limit = 10, showVariants = false }) => {
    if (restart) await dispatch('resetBillingList')
    if (tipo === '05' && state.servicioBillingList.length) {
      console.log('servicios de factura ⏩')
      return state.servicioBillingList
    }

    if (tipo === '02' && state.productoBillingList.length) {
      console.log('productos de factura ⏩')

      return state.productoBillingList
    }

    if (tipo === 'N') {
      console.log('todos los items from db 🥵')
      return service.readToBill(rootGetters['facturacion/emisorStore/get_Id'], tipo, limit, showVariants).then(result => {
        // commit('SET_PRODUCTO_BILLING_LIST', { obj: result }) validar cuando debe cargar todo en el store.

        return result.feed
      })
    }

    // busca reventas y manufacturados para crear una sola lista de Productos
    if (tipo !== '05') {
      console.log('productos de factura from db 🥵')

      // TODO: es mejor hacer una sola consula que carge reventa y manufacturados
      await service.readToBill(rootGetters['facturacion/emisorStore/get_Id'], '03', limit).then(result => {
        commit('SET_PRODUCTO_BILLING_LIST', { obj: result })
      })
      return service.readToBill(rootGetters['facturacion/emisorStore/get_Id'], '02', limit).then(result => {
        commit('SET_PRODUCTO_BILLING_LIST', { obj: result })
      })
    }

    // busca servicios
    console.log('servicios de factura from db 🥵')
    return service.readToBill(rootGetters['facturacion/emisorStore/get_Id'], tipo, limit).then(result => {
      commit('SET_SERVICIO_BILLING_LIST', { obj: result })
    })
  },
  readAllItemByEmisor: async ({ commit, rootGetters, state }, force = false) => {
    if (state.completeList.length && !force) {
      console.log('item list from cache ⏩')
      return state.completeList
    }

    console.log('item list from DB 😿')

    return service.readAllItemByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      commit('SET_COMPLETE_LIST', result)

      return true
    })
  },

  delete: ({ commit, rootGetters }, { items, storeList }) =>
    service.delete(rootGetters['facturacion/emisorStore/get_Id'], items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i, storeList })
      })
      return result
    }),

  itemCostoPromedio: ({ commit }, _idItem) =>
    service.itemCostoPromedio(_idItem).then(result => {
      commit('SET_PP', result)
      return result
    }),

  // TODO: subs
  // subscriptionNewMateriaPrima: ({ commit, rootGetters }) =>
  //   service.subscriptionNewMateriaPrima(rootGetters['facturacion/emisorStore/get_Id'], result => commit('UPDATE_FACTURAS', result)),

  saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input),

  healthCheck: () => service.healthCheck(),

  resetVariantList: ({ state }) => {
    console.log('reset variant list')
    state.listVariants = []
  },

  readVariantsToBill: async ({ state }, { _id, restart = false }) => {
    if (restart) state.listVariantsToBill = []

    // cache
    const hasVariants = state.listVariantsToBill.filter(e => e.itemRefId === _id)

    if (hasVariants?.length) {
      state.variantsToBill = hasVariants

      console.log('Variants to bill from cache ⏩')

      return
    }

    const variantsToBill = await service.readVariantsToBill(_id)
    console.log('Variants to bill from DB 🥲')

    const regex = /\[(.*?)\]/g
    const varItems = variantsToBill.map(item => ({
      ...item,
      nombre: item.nombre.match(regex)[0].slice(1, -1)
    }))

    state.variantsToBill = varItems
    state.listVariantsToBill = [...state.listVariantsToBill, ...varItems]

    return varItems
  },

  readVariantsByItem: async ({ state, dispatch }, { _id, restart = false, saveInVariantsToBill = false }) => {
    if (restart) await dispatch('resetVariantList')

    // cache
    let hasVariant = state.listVariants.filter(e => e.itemRefId?.toString() === _id.toString())

    if (hasVariant?.length) {
      state.variants = hasVariant
      console.log('Variants from cache ⏩')
      return
    }

    const variants = await service.readVariantsByItem(_id)
    console.log('Variants from DB 🥲')

    const regex = /\[(.*?)\]/g
    const varItems = variants.map(item => ({
      ...item,
      nombre: item.nombre.match(regex)[0].slice(1, -1)
      // nombreEN: item.nombreEN?.match(regex)[0].slice(1, -1) ?? '' ahora el nombre en inglés no tiene los atributos entre []
    }))

    state.variants = varItems // lista de variantes de un item seleccionado
    state.listVariants = [...state.listVariants, ...varItems] // cache

    if (saveInVariantsToBill) {
      state.variantsToBill = varItems
      state.listVariantsToBill = [...state.listVariantsToBill, ...varItems]
    }

    return
  },

  saveVariant: async ({ state }, variant) => {
    return service.saveVariant({
      _id: variant._id,
      emisor: variant.emisor,
      nombre: `${state.item.nombre} [${variant.nombre}]`,
      minimo: Number(variant.minimo),
      maximo: Number(variant.maximo),
      costoUnitarioTotal: variant.costoUnitarioTotal,
      // precioExtra: variant.precioExtra,
      costoExtra: variant.costoExtra,
      esCompuesto: variant.esCompuesto,
      ...(variant.esCompuesto && {
        composicion: variant.composicion.map(e => ({
          ...e,
          porcion: Number(e.porcion)
        }))
      }),
      listaCostos: variant.listaCostos,
      options: variant.options,

      precioInvertido: variant.precioInvertido,
      precioUnitario: Number(variant.precioUnitario),
      utilidad: Number(variant.utilidad),
      precioVenta: Number(variant.precioVenta),
      customVariantPrice: variant.customVariantPrice || false,
      impuesto: variant.impuesto,
      posIndex: variant.posIndex || 99999
    })
  },

  setImage: async ({ state, rootGetters }, { newimg }) => {
    const name = 'main'

    return service.setImage(rootGetters['facturacion/emisorStore/get_Id'], state.item._id, newimg, name).then(res => {
      state.item.img = { src: res }
    })
  },

  deleteImage: async ({ state }, name) => {
    return service.deleteImage(state.item._id, name)
  },

  costCalc({ state, rootGetters }) {
    state.item.descuentos = 0 // en materia prima no hay descuentos, se deben ingresar en la compra.

    // impuestos
    const IVA = state.item.impuesto?.reduce((acc, i) => acc + i.tarifa, 0) || 0

    state.item.impuestos = Number(((state.item.costoUnitarioTotal - state.item.descuentos) * (IVA / 100)).toFixed(5))
    state.item.pimpuesto = IVA

    state.item.utilidad = 0
    state.item.precioUnitario = 0

    state.item.precioCompra = Number((state.item.costoUnitarioTotal - state.item.descuentos + state.item.impuestos).toFixed(5))
  },

  pricingCalc: ({ state, rootGetters }) => {
    if (!state.item.impuesto && !state.item.descuento) return

    const IVA = state.item.impuesto?.reduce((acc, i) => acc + i.tarifa, 0) || 0
    const SCALE = 100000n // 5 decimales exactos

    // Convertimos a BigInt
    const precioVentaEditable = BigInt(Math.round(state.precioVentaEditable.value * Number(SCALE)))

    // precio sin impuestos
    const divisorIVA = BigInt(1e5 + Math.round(IVA * 1000)) // (1 + IVA/100) * 100000
    const antesImpuestosRaw = (precioVentaEditable * SCALE) / divisorIVA

    // precio unitario
    const precioUnitarioRaw = antesImpuestosRaw

    state.item.precioUnitario = Number(precioUnitarioRaw) / Number(SCALE)

    // descuentos en enteros
    let descuentosRaw = 0n
    state.item.pdescuento = 0

    for (const e of state.item.descuento) {
      const desc = rootGetters['inventario/descuentoStore/get'](e._id)

      if (desc) {
        const monto = BigInt(Math.round(desc.montoDescuento * Number(SCALE)))
        const porc = (precioUnitarioRaw * BigInt(desc.porcentajeDescuento)) / 100n
        descuentosRaw += monto + porc
        state.item.pdescuento += desc.porcentajeDescuento
      }
    }

    state.item.descuentos = Number(descuentosRaw) / Number(SCALE)

    // subtotal
    const subtotalRaw = precioUnitarioRaw - descuentosRaw
    state.item.subtotal = Number(subtotalRaw) / Number(SCALE)

    // costo
    const costoRaw = BigInt(Math.round(state.item.costoUnitarioTotal * Number(SCALE)))

    // utilidad %
    const utilidad = Number(((Number(subtotalRaw - costoRaw) / Number(subtotalRaw)) * 100).toFixed(2))
    state.item.utilidad = utilidad

    // impuestos exactos
    const impuestosRaw = (subtotalRaw * BigInt(IVA)) / 100n
    state.item.impuestos = Number(impuestosRaw) / Number(SCALE)
    state.item.pimpuesto = IVA

    // total venta exacto
    const totalRaw = subtotalRaw + impuestosRaw
    state.item.precioVenta = Number(totalRaw) / Number(SCALE)

    // ganancia
    const gananciaRaw = precioUnitarioRaw - costoRaw - descuentosRaw
    state.item.ganancia = Number(gananciaRaw) / Number(SCALE)
  }
}

export const getters = {
  get: state => item => {
    return state[item.storeList].find(e => e._id === item._id)
  },
  getBillVariant: state => _id => state.variantsToBill.find(v => v._id === _id),
  getVariants: state => _id => state.listVariants.filter(v => v.itemRefId === _id),
  hasProductoBillingList: state => state.productoBillingList?.length || 0,
  hasItemsCompras: state => state.itemsCompras?.length || 0,
  hasMovimientos: state => state.stock?.length || 0,
  hasList: state => storeList => state[storeList]?.length || 0
}
